import styled from 'styled-components';

export const ConfirmationKycContainer = styled.main`
    div {
        margin-top: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .title {
            font-size: 20px;
            font-weight: bold;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/kyc/ConfirmationKycPageStyle.js